import React from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router';
import AutomatedTestScenarioGenerator from '../components/projects/AutomatedTestScenarioGenerator';
import { AppShell } from '../components/layout';
import { useWorkspace } from '../context/WorkspaceContext';
import { useProject } from '../context/ProjectContext';
import { buildWorkspaceDashboardPath } from '../utils/workspaceRouteUtils';

const AutomatedTestScenarioGeneratorPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { currentWorkspace } = useWorkspace();
  const { selectedProject } = useProject();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const projectId =
    searchParams.get('project_id') || selectedProject?.id || null;
  const workspaceId = currentWorkspace?.id;

  const handleBack = () => {
    if (workspaceId && projectId) {
      navigate(
        buildWorkspaceDashboardPath(workspaceId, projectId, 'requirements/jira')
      );
      return;
    }
    if (workspaceId) {
      navigate(buildWorkspaceDashboardPath(workspaceId, null, 'projects'));
      return;
    }
    navigate(-1);
  };

  return (
    <AppShell
      user={user}
      onLogout={() => {
        localStorage.removeItem('isAuthenticated');
        localStorage.removeItem('user');
        navigate('/auth/login');
      }}
    >
      <AutomatedTestScenarioGenerator
        item={{ id, key: id, summary: `Item ${id}` }}
        itemType="story"
        projectId={projectId}
        onClose={handleBack}
      />
    </AppShell>
  );
};

export default AutomatedTestScenarioGeneratorPage;
